import { jsx as r } from "react/jsx-runtime";
import { Box as m } from "@mui/material";
import { Typography as a } from "./index59.mjs";
import { progressBarLabelClasses as p } from "./constants4.mjs";
import { mergeClassNames as i } from "./mergeClassNames.mjs";
const h = ({
  label: o,
  className: e,
  ...s
}) => /* @__PURE__ */ r(
  m,
  {
    ...s,
    className: i([p.root, e]),
    children: /* @__PURE__ */ r(
      a.Body1,
      {
        sx: {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        },
        children: o
      }
    )
  }
);
export {
  h as ProgressBarLabel
};
//# sourceMappingURL=index132.mjs.map
